import React from 'react'

type DiscountBadgeOrderTabIconProps = {
  testId?: string
}

export function DiscountBadgeOrderTabIcon({ testId }: DiscountBadgeOrderTabIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      data-testid={testId}
    >
      <circle cx="8" cy="8" r="8" fill="currentColor" />
      <path d="M5.05 10.95L10.95 5.05" stroke="white" strokeWidth="1.35" strokeLinecap="round" />
      <circle cx="5.25" cy="5.35" r="1.15" stroke="white" strokeWidth="1.2" />
      <circle cx="10.75" cy="10.65" r="1.15" stroke="white" strokeWidth="1.2" />
    </svg>
  )
}
